// React & Router
import React, { Component } from 'react';
import { Link } from 'react-router-dom';

// HTTP Client
import axios from 'axios';

// jwt_decode
import { jwtDecode } from 'jwt-decode';

// sweetalert2
import Swal from 'sweetalert2'
import $ from 'jquery';

// Bootstrap Components
import { Container, Row, Col, Breadcrumb } from 'react-bootstrap';

// RSuite UI Components (เรียกผ่าน Rsuite namespace)
import { Stack, HStack, VStack, FlexboxGrid, Button, Calendar, Modal, Input, InputNumber, Panel, SelectPicker, Loader, IconButton, CheckboxGroup, Checkbox, RadioGroup, Radio, Toggle, Text, Tooltip, Whisper } from 'rsuite';

// Thai date picker component
import { ThaiDatePicker } from 'thaidatepicker-react';

import * as XLSX from "xlsx";

export default class CounselingAdminPage extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isMobile: window.innerWidth < 480,
            content: null,
            modal: null,
            loading: false,
            events: [],
            month: new Date().getMonth() + 1,
            year: new Date().getFullYear(),
            status: true,
            mode: 'insert',
            full_name: '',
            nickname: '',
            age: '',
            year_level: '',
            gender: '',
            youth_type: '',
            date: '',
            consultant: '',
            topics: [],
            detail: '',
            suggestion: '',
            advice: [],
            recommendation: '',
            follow_up: '',
            cooperation: 'A',
            totalSubmitted: 0,
            waitingForRecommendation: 0,
            recommended: 0,
            approvedStudents: [],
        };

        this.handleResize = this.handleResize.bind(this);
    }

    async componentDidMount() {
        const token = localStorage.getItem('token');

        if (!token) {
            window.location.href = '/admin/login';
            return;
        }

        try {
            const decoded = jwtDecode(token);
            const currentTime = Date.now() / 1000;

            if (decoded.exp < currentTime) {
                localStorage.removeItem('token');
                window.location.href = '/admin/login';
                return;
            }

            const authHeader = {
                headers: { Authorization: `Bearer ${token}` }
            };

            await this.promisedSetState({ authHeader });

            try {
                // ส่งเดือนและปีเข้า onRenderContent
                await this.onRenderContent({ mode: 'read' });
            } catch (error) {
                console.error('Failed to fetch application data:', error);
            }

            window.addEventListener('resize', this.handleResize);

        } catch (error) {
            console.error('Invalid token:', error);
            localStorage.removeItem('token');
            window.location.href = '/admin/login';
        }
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize);
    }

    handleResize() {
        this.setState({ isMobile: window.innerWidth < 480 });
    }

    promisedSetState = (newState) => new Promise(resolve =>
        this.setState(newState, resolve)
    );

    formatThaiDate(dateString) {
        const monthsThai = [
            "มกราคม", "กุมภาพันธ์", "มีนาคม", "เมษายน", "พฤษภาคม", "มิถุนายน",
            "กรกฎาคม", "สิงหาคม", "กันยายน", "ตุลาคม", "พฤศจิกายน", "ธันวาคม"
        ];

        const date = new Date(dateString);
        const day = date.getDate();
        const month = monthsThai[date.getMonth()];
        const year = date.getFullYear() + 543;

        return `วันที่ ${day} ${month} ${year}`;
    }


    // ✅ ดึง events จากทั้งสองแหล่ง
    fetchEventDays = async (month, year) => {
        const res = await axios.get(
            `${process.env.REACT_APP_API}/events/month-year/${month}/${year}`,
            this.state.authHeader
        );

        const eventsApiData = res.data;

        const events = eventsApiData
            .filter(e => e.status === false)
            .map(e => {
                const date = new Date(e.date);
                date.setDate(date.getDate() - 1);

                return {
                    id: e.id,
                    date: date.toISOString().split('T')[0],
                    title: 'ไม่ว่าง'
                };
            });

        return events;
    };

    fetchConsultationEvents = async (month, year) => {
        const res = await axios.get(
            `${process.env.REACT_APP_API}/student-consultation/month-year/${month}/${year}`,
            this.state.authHeader
        );

        const consultations = res.data;

        // emoji จาก symbol ของ student_consultations
        const symbolEmojiMap = {
            smile: '😊',
            cool: '😎',
            happy: '😁',
            curious: '🤔',
            whale: '🐳',
            flower: '🌸',
            heart: '❤️',
            dove: '🕊️',
            butterfly: '🦋',
            turtle: '🐢',
            star: '⭐',
            rainbow: '🌈'
        };

        // emoji สำหรับ admin
        const adminEmoji = '👩‍💼';

        const events = consultations.map(item => {

            const date = new Date(item.date);
            date.setDate(date.getDate() - 1);

            let emoji;

            // ถ้ามี consultation → ใช้ symbol
            if (item.symbol && symbolEmojiMap[item.symbol]) {
                emoji = symbolEmojiMap[item.symbol];
            }
            // ถ้าไม่มี consultation → ใช้ emoji admin
            else {
                emoji = adminEmoji;
            }

            return {
                id: item.id,
                date: date.toISOString().split('T')[0],
                title: emoji,
                recommendation_id: item.recommendation_id,
                recommended: item.hasRecommendation,
                by_admin: item.by_admin
            };
        });

        return events;
    };

    // ✅ ฟังก์ชันหลักที่รวมข้อมูล
    fetchAllCalendarEvents = async (month, year) => {
        try {
            await this.promisedSetState({ loading: true });

            // ✅ เรียก summary ก่อน และรอให้เสร็จ
            await this.fetchConsultationSummary();

            // ✅ แล้วค่อยโหลด calendar
            const [busyEvents, consultationEvents] = await Promise.all([
                this.fetchEventDays(month, year),
                this.fetchConsultationEvents(month, year)
            ]);

            const allEvents = [...busyEvents, ...consultationEvents];

            await this.promisedSetState({
                events: allEvents,
                month,
                year,
                loading: false
            });

            this.updateContent();

        } catch (error) {
            console.error('Error loading calendar events:', error);
            window.location.href = '/admin/login';
        }
    };

    fetchConsultationSummary = async () => {
        try {
            const res = await axios.post(
                `${process.env.REACT_APP_API}/student-consultation/recommendation-summary`,
                {
                    start_date: this.state.SeachStartDate,
                    end_date: this.state.SeachEndDate
                },
                this.state.authHeader
            );

            this.setState({
                totalSubmitted: res.data.totalSubmitted || 0,
                waitingForRecommendation: res.data.waitingForRecommendation || 0,
                recommended: res.data.recommended || 0,
            });

        } catch (err) {
            this.setState({
                error: err.message || 'Error fetching data',
                totalSubmitted: 0,
                waitingForRecommendation: 0,
                recommended: 0,
            });
        }
    };

    handleToggle = () => {
        this.setState(prevState => ({ isOpen: !prevState.isOpen }), () => {
            // เรียกใช้งาน callback หลัง toggle
            this.onRenderContent({ mode: 'read' });
        });
    };

    // ฟังก์ชันสร้าง content โดยใช้ this.state.events
    updateContent = () => {
        const { events, isMobile } = this.state;

        const renderCell = (date) => {
            const day = new Date(date.toISOString().split('T')[0]);
            const dayEvents = events.filter(event => {
                const eventDate = new Date(event.date);
                return eventDate.toDateString() === day.toDateString();
            });

            if (dayEvents.length === 0) {
                return (
                    <div
                        onClick={() => {
                            const nextDate = new Date(date);
                            nextDate.setDate(nextDate.getDate() + 1);

                            const formattedDate = nextDate.toISOString().split('T')[0];

                            this.promisedSetState({
                                modal: (
                                    <Modal
                                        size="xs"
                                        backdrop="static"
                                        keyboard={false}
                                        centered
                                        open={true}
                                        style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                                        onClose={() => this.setState({ modal: null })}
                                    >
                                        <Modal.Body>

                                            <div style={{
                                                display: 'flex',
                                                flexDirection: 'column',
                                                gap: '10px'
                                            }}>

                                                {/* กำหนดตารางงาน */}
                                                <div
                                                    onClick={() => {
                                                        this.setState({ modal: null }, () =>
                                                            this.onBusy({
                                                                type: 'schedule',
                                                                mode: 'insert',
                                                                date: formattedDate
                                                            })
                                                        );
                                                    }}
                                                    style={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        gap: '14px',
                                                        padding: '14px',
                                                        borderRadius: '8px',
                                                        border: '1px solid #E7E5E4',
                                                        cursor: 'pointer',
                                                        transition: 'border-color 0.2s'
                                                    }}
                                                    onMouseEnter={(e) => {
                                                        e.currentTarget.style.borderColor = '#0d6efd';
                                                    }}
                                                    onMouseLeave={(e) => {
                                                        e.currentTarget.style.borderColor = '#E7E5E4';
                                                    }}
                                                >

                                                    <i
                                                        className="bi bi-calendar-check"
                                                        style={{
                                                            fontSize: '28px',
                                                            color: '#0d6efd'
                                                        }}
                                                    ></i>

                                                    <div>
                                                        <div style={{
                                                            fontWeight: '600',
                                                        }}>
                                                            กำหนดตารางงาน
                                                        </div>

                                                        <div style={{
                                                            fontSize: '18px',
                                                            color: '#777'
                                                        }}>
                                                            กำหนดวันว่างหรือไม่ว่าง
                                                        </div>
                                                    </div>

                                                </div>


                                                {/* บันทึกคำปรึกษา */}
                                                <div
                                                    onClick={() => {
                                                        this.setState({ modal: null }, () =>
                                                            this.onModal({
                                                                mode: 'insert',
                                                                id: null,
                                                                sel: false,
                                                                comfirm_id: null,
                                                                by_admin: false,
                                                                type: 'consult',
                                                                date: formattedDate
                                                            })
                                                        );
                                                    }}
                                                    style={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        gap: '14px',
                                                        padding: '14px',
                                                        borderRadius: '8px',
                                                        border: '1px solid #E7E5E4',
                                                        cursor: 'pointer',
                                                        transition: 'border-color 0.2s'
                                                    }}
                                                    onMouseEnter={(e) => {
                                                        e.currentTarget.style.borderColor = '#16a34a';
                                                    }}
                                                    onMouseLeave={(e) => {
                                                        e.currentTarget.style.borderColor = '#E7E5E4';
                                                    }}
                                                >

                                                    <i
                                                        className="bi bi-chat-dots"
                                                        style={{
                                                            fontSize: '28px',
                                                            color: '#16a34a'
                                                        }}
                                                    ></i>

                                                    <div>
                                                        <div style={{
                                                            fontWeight: '600',
                                                        }}>
                                                            บันทึกการให้คำปรึกษา
                                                        </div>

                                                        <div style={{
                                                            fontSize: '18px',
                                                            color: '#777'
                                                        }}>
                                                            เพิ่มข้อมูลการให้คำปรึกษา
                                                        </div>
                                                    </div>

                                                </div>

                                            </div>

                                        </Modal.Body>

                                        <Modal.Footer>
                                            <Button
                                                appearance="subtle"
                                                onClick={() => this.setState({ modal: null })}
                                            >
                                                ยกเลิก
                                            </Button>
                                        </Modal.Footer>

                                    </Modal>
                                )
                            });
                        }}
                        style={{
                            width: '100%',
                            height: '100%',
                            cursor: 'pointer',
                            borderRadius: '8px',
                            transition: 'background 0.2s',
                        }}
                        onMouseEnter={(e) => e.currentTarget.style.background = '#E9FCE9'}
                        onMouseLeave={(e) => e.currentTarget.style.background = 'transparent'}
                    ></div>
                );
            }

            const busyEvent = dayEvents.find(ev => ev.title === 'ไม่ว่าง');
            const emojiEvents = dayEvents.filter(ev => ev.title !== 'ไม่ว่าง');

            if (emojiEvents.length > 0) {
                return (
                    <div
                        style={{
                            borderRadius: '25px',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            fontSize: '1.6rem',
                            flexWrap: 'wrap',
                            gap: '6px',
                            flexDirection: isMobile ? 'column' : 'row',
                        }}
                    >

                        <div style={{ display: 'flex', gap: isMobile ? '4px' : '6px', flexWrap: 'wrap' }}>
                            {/* แสดง 4 ตัวแรก */}
                            {emojiEvents.slice(0, 4).map((event, index) => (
                                <Whisper
                                    key={index}
                                    placement="top"
                                    trigger="click"
                                    speaker={
                                        <Tooltip style={{ padding: '8px', display: 'flex', flexDirection: 'column', gap: '4px' }}>
                                            <Button
                                                size="sm"
                                                appearance="primary"
                                                onClick={() => this.onModal({
                                                    mode: event.recommended && event.recommendation_id ? 'update' : 'insert',
                                                    id: event.id,
                                                    comfirm_id: event.recommended && event.recommendation_id ? event.recommendation_id : event.id,
                                                    by_admin: event.by_admin
                                                })}
                                            >
                                                บันทึกคำปรึกษา
                                            </Button>
                                            <Button
                                                size="sm"
                                                appearance="primary"
                                                color="red"
                                                onClick={() => this.onConfirm({ form: 'consult', mode: 'delete', id: event.recommendation_id })}
                                            >
                                                ลบ
                                            </Button>
                                        </Tooltip>
                                    }
                                >
                                    <span
                                        style={{
                                            backgroundColor: '#E3F2FD',
                                            borderRadius: '50%',
                                            width: isMobile ? '18px' : '24px',
                                            height: isMobile ? '18px' : '24px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            fontSize: isMobile ? '0.9rem' : '1.2rem',
                                            boxShadow: '0 0 2px rgba(0,0,0,0.1)',
                                            cursor: 'pointer',
                                            position: 'relative',
                                        }}
                                    >
                                        {event.recommended && (
                                            <i
                                                className="bi bi-check"
                                                style={{
                                                    position: 'absolute',
                                                    top: '12px',
                                                    right: isMobile ? '-4px' : '-8px',
                                                    color: 'green',
                                                    fontSize: isMobile ? '1rem' : '1.4rem',
                                                }}
                                            ></i>
                                        )}
                                        {event.title}
                                    </span>
                                </Whisper>
                            ))}

                            {/* แสดง +N */}
                            {emojiEvents.length > 4 && (
                                <Whisper
                                    placement="top"
                                    trigger="click"
                                    speaker={
                                        <Tooltip style={{ padding: '8px', display: 'flex', flexDirection: 'column', gap: '4px' }}>
                                            {emojiEvents.slice(4).map((event, i) => (
                                                <div key={i} style={{ display: 'flex', gap: '4px', alignItems: 'center' }}>
                                                    <span>{event.title}</span>
                                                    <Button
                                                        size="xs"
                                                        appearance="primary"
                                                        onClick={() => this.onModal({
                                                            mode: event.recommended && event.recommendation_id ? 'update' : 'insert',
                                                            id: event.id,
                                                            comfirm_id: event.recommended && event.recommendation_id ? event.recommendation_id : event.id,
                                                            by_admin: event.by_admin
                                                        })}
                                                    >
                                                        บันทึกคำปรึกษา
                                                    </Button>
                                                    <Button
                                                        size="xs"
                                                        appearance="primary"
                                                        color="red"
                                                        onClick={() => this.onConfirm({ form: 'consult', mode: 'delete', id: event.recommendation_id })}
                                                    >
                                                        ลบ
                                                    </Button>
                                                </div>
                                            ))}
                                        </Tooltip>
                                    }
                                >
                                    <span
                                        style={{
                                            backgroundColor: '#E3F2FD',
                                            borderRadius: '50%',
                                            width: isMobile ? '18px' : '24px',
                                            height: isMobile ? '18px' : '24px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            fontSize: isMobile ? '0.6rem' : '0.8rem',
                                            boxShadow: '0 0 2px rgba(0,0,0,0.1)',
                                            cursor: 'pointer',
                                        }}
                                    >
                                        +{emojiEvents.length - 4}
                                    </span>
                                </Whisper>
                            )}
                        </div>
                        <div
                            style={{
                                width: '100%',
                                display: 'flex',
                                justifyContent: 'center',
                            }}
                        >
                            <span
                                onClick={() => {
                                    const nextDate = new Date(date);        // clone วันที่ปัจจุบัน
                                    nextDate.setDate(nextDate.getDate() + 1); // เพิ่ม 1 วัน

                                    this.onModal({
                                        mode: 'insert',
                                        id: null,
                                        sel: false,
                                        comfirm_id: null,
                                        by_admin: false,
                                        type: 'consult',
                                        date: nextDate.toISOString().split('T')[0] // format YYYY-MM-DD
                                    });
                                }}
                                style={{
                                    width: '24px',
                                    height: '20px',
                                    borderRadius: '6px',
                                    background: '#f1f3f5',
                                    color: '#6c757d',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    fontSize: '16px',
                                    cursor: 'pointer',
                                    transition: 'all 0.2s'
                                }}
                                onMouseEnter={(e) => e.currentTarget.style.background = '#e9ecef'}
                                onMouseLeave={(e) => e.currentTarget.style.background = '#f1f3f5'}
                            >
                                +
                            </span>
                        </div>
                    </div>
                );
            }

            if (busyEvent) {
                return isMobile ? (
                    <i
                        className="bi bi-x-circle-fill"
                        style={{ color: '#D32F2F', fontSize: '20px' }}
                        onClick={() =>
                            this.onBusy({
                                type: 'schedule',
                                mode: 'update',
                                date: new Date(
                                    new Date(busyEvent.date).setDate(
                                        new Date(busyEvent.date).getDate() + 1
                                    )
                                ),
                                id: busyEvent.id
                            })
                        }
                    ></i>
                ) : (
                    <div
                        onClick={() =>
                            this.onBusy({
                                type: 'schedule',
                                mode: 'update',
                                date: new Date(
                                    new Date(busyEvent.date).setDate(
                                        new Date(busyEvent.date).getDate() + 1
                                    )
                                ),
                                id: busyEvent.id
                            })
                        }
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            flexWrap: 'wrap',
                            backgroundColor: '#FFEBEE',
                            borderRadius: '25px',
                            padding: '8px 16px',
                            gap: '8px',
                            maxWidth: '100%',
                            boxSizing: 'border-box',
                            cursor: 'pointer'
                        }}
                    >
                        <span
                            style={{
                                width: '8px',
                                height: '8px',
                                borderRadius: '50%',
                                backgroundColor: busyEvent.color,
                                display: 'inline-block',
                            }}
                        ></span>

                        <span
                            style={{
                                color: '#D32F2F',
                                fontSize: '20px',
                                wordBreak: 'break-word',
                            }}
                        >
                            {busyEvent.title}
                        </span>
                    </div>
                );
            }
            return null;
        };

        this.promisedSetState({
            content: (
                <>
                    <Row className='mt-3'>
                        <Col>
                            <Breadcrumb size='lg'>
                                <Breadcrumb.Item>
                                    <Link to="/admin">
                                        <i className="bi bi-house-fill"></i>
                                    </Link>
                                </Breadcrumb.Item>
                                <Breadcrumb.Item active>การให้คำปรึกษา</Breadcrumb.Item>
                            </Breadcrumb>
                        </Col>
                    </Row>

                    <Row>
                        <Col lg={6} className='mb-2'>
                            <Panel
                                header="รอคำปรึกษา"
                                className="shadow-sm"
                                style={{
                                    backgroundColor: '#ffffff',
                                    padding: '0.3em',
                                    borderLeft: '5px solid #ffc107'
                                }}
                            >
                                <div className="text-center">
                                    <Text style={{ fontSize: '3rem', color: '#ffc107', fontWeight: 'bold' }}>
                                        {this.state.waitingForRecommendation}
                                    </Text>
                                </div>
                            </Panel>
                        </Col>

                        <Col lg={6} className='mb-2'>
                            <Panel
                                header="ให้คำปรึกษาแล้ว"
                                className="shadow-sm"
                                style={{
                                    backgroundColor: '#ffffff',
                                    padding: '0.3em',
                                    borderLeft: '5px solid #198754'
                                }}
                            >
                                <div className="text-center">
                                    <Text style={{ fontSize: '3rem', color: '#198754', fontWeight: 'bold' }}>
                                        {this.state.recommended}
                                    </Text>
                                </div>
                            </Panel>
                        </Col>
                    </Row>

                    {this.state.isOpen && (
                        <Row className='mt-3'>
                            <Col lg={3} className='mb-3'>
                                <HStack>
                                    <label><b>วันที่</b></label>
                                    <div className='jnCan' style={{ display: 'flex', alignItems: 'center' }}>
                                        <ThaiDatePicker
                                            placeholder="วัน/เดือน/ปี พ.ศ."
                                            value={this.state.SeachStartDate}
                                            inputProps={{
                                                style: {
                                                    padding: '6px 8px',
                                                    borderRadius: '6px 0 0 6px',
                                                    border: '1px solid #E7E5E4',
                                                    width: '200px',
                                                }
                                            }}
                                            onChange={async (e) => {
                                                await this.promisedSetState({ SeachStartDate: e });
                                                this.onRenderContent({ mode: 'read' });
                                            }}
                                            onClean={async () => {
                                                await this.promisedSetState({ SeachStartDate: '' });
                                                this.onRenderContent({ mode: 'read' });
                                            }}
                                        />
                                        <IconButton
                                            icon={<i className="bi bi-calendar3"></i>}
                                            size="md"
                                            style={{
                                                borderRadius: '0 6px 6px 0', // top-left 0, top-right 6px, bottom-right 6px, bottom-left 0
                                            }}
                                        />
                                    </div>
                                </HStack>
                            </Col>
                            <Col lg={3} className='mb-3'>
                                <HStack>
                                    <label><b>ถึง</b></label>
                                    <div className='jnCan' style={{ display: 'flex', alignItems: 'center' }}>
                                        <ThaiDatePicker
                                            placeholder="วัน/เดือน/ปี พ.ศ."
                                            value={this.state.SeachEndDate}
                                            inputProps={{
                                                style: {
                                                    padding: '6px 8px',
                                                    borderRadius: '6px 0 0 6px',
                                                    border: '1px solid #E7E5E4',
                                                    width: '200px',
                                                }
                                            }}
                                            onChange={async (e) => {
                                                await this.promisedSetState({ SeachEndDate: e });
                                                this.onRenderContent({ mode: 'read' });
                                            }}
                                            onClean={async () => {
                                                await this.promisedSetState({ SeachEndDate: '' });
                                                this.onRenderContent({ mode: 'read' });
                                            }}
                                        />
                                        <IconButton
                                            icon={<i className="bi bi-calendar3"></i>}
                                            size="md"
                                            style={{
                                                borderRadius: '0 6px 6px 0', // top-left 0, top-right 6px, bottom-right 6px, bottom-left 0
                                            }}
                                        />
                                    </div>
                                </HStack>
                            </Col>
                        </Row>
                    )}

                    <Row className="mb-2 mt-2" style={{ alignItems: 'center' }}>
                        {/* ปุ่มด้านซ้าย */}
                        <Col style={{ display: 'flex', justifyContent: 'flex-start' }}>
                            <Button
                                size="sm"
                                appearance='primary'
                                startIcon={<i className="bi bi-plus-lg"></i>}
                                onClick={() => this.onModal({
                                    mode: 'insert',
                                    id: null,
                                    sel: false,
                                    comfirm_id: null,
                                    by_admin: false,
                                    type: 'consult',
                                    date: ''
                                })}
                            >
                                เพิ่มบันทึกคำปรึกษา
                            </Button>
                        </Col>

                        {/* ปุ่มด้านขวา */}
                        <Col
                            style={{
                                display: 'flex',
                                justifyContent: 'flex-end',
                                alignItems: 'center',
                                gap: '12px'
                            }}
                        >
                            <Toggle
                                size="md"
                                checked={this.state.isOpen}
                                onChange={this.handleToggle}
                                style={{ display: 'flex', alignItems: 'center', gap: '6px' }}
                            >
                                <Text muted>ตัวกรอง</Text>
                            </Toggle>

                            <Button
                                size="sm"
                                onClick={this.downloadExcel}
                                style={{
                                    backgroundColor: '#E8F5E9',
                                    color: '#1D6F42',
                                    border: 'none',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '6px',
                                    fontWeight: 500,
                                    padding: '6px 10px',
                                    borderRadius: '6px'
                                }}
                            >
                                <i className="bi bi-file-earmark-excel-fill"></i>
                                ดาวน์โหลด Excel
                            </Button>
                        </Col>
                    </Row>

                    <Row>
                        <Col lg={12} className='mb-3'>
                            <Panel
                                header="ตารางการให้คำปรึกษา"
                                className="shadow-sm"
                                style={{
                                    backgroundColor: '#FFF',
                                    padding: '0.5em',
                                    height: '100%'
                                }}
                            >
                                <Row>
                                    <Col className="mb-3">
                                        <div style={{ overflowX: 'auto' }}>
                                            <div style={{ minWidth: '600px' }}>
                                                <Calendar
                                                    bordered
                                                    renderCell={renderCell}
                                                    onMonthChange={e =>
                                                        this.fetchAllCalendarEvents(
                                                            e.getMonth() + 1,
                                                            e.getFullYear()
                                                        )
                                                    }
                                                />
                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                            </Panel>
                        </Col>
                    </Row>
                </>
            ),
            loading: false
        });
    };

    // ปรับ onRenderContent ให้เรียก fetchEvents แทนดึงข้อมูลเอง
    onRenderContent = async ({ mode }) => {
        if (mode === 'read') {
            this.fetchAllCalendarEvents(this.state.month, this.state.year);
        }
    };

    onBusy = async ({ type, mode, date, id, sel }) => {

        let newState = {};

        if (!sel && type === "schedule") {

            if (mode === 'update') {

                const res = await axios.get(
                    `${process.env.REACT_APP_API}/events/${id}`,
                    this.state.authHeader
                );

                const { date: fetchedDate, status } = res.data;

                newState = {
                    date: fetchedDate,
                    status
                };

            } else {

                if (date) newState.date = date;
                newState.status = true;

            }

            await this.promisedSetState(newState);
        }

        const { date: stateDate, status } = this.state;

        let modalContent = null;

        if (type === "schedule") {

            modalContent = (

                <Modal
                    size="xs"
                    backdrop="static"
                    keyboard={false}
                    open={true}
                    onClose={() => this.setState({ modal: null })}
                >

                    <Modal.Header>
                        <Modal.Title
                            style={{ fontWeight: '700', fontSize: '1.4rem' }}
                        >
                            ตารางงาน
                        </Modal.Title>
                    </Modal.Header>

                    <Modal.Body>

                        <Container fluid>

                            <Row>
                                <Col className="mb-3">
                                    <VStack>

                                        <label>
                                            วันที่
                                            <span className="text-danger"> *</span>
                                        </label>

                                        <ThaiDatePicker
                                            placeholder="วัน/เดือน/ปี พ.ศ."
                                            value={stateDate}
                                            inputProps={{
                                                style: {
                                                    padding: '6px 8px',
                                                    borderRadius: '6px',
                                                    border: '1px solid #E7E5E4',
                                                    width: '200px'
                                                }
                                            }}
                                            onChange={async e => {

                                                await this.promisedSetState({
                                                    date: e
                                                });

                                                this.onBusy({
                                                    type: "schedule",
                                                    mode,
                                                    date: e,
                                                    id,
                                                    sel: true
                                                });

                                            }}
                                        />

                                    </VStack>
                                </Col>
                            </Row>

                            <Row>
                                <Col>

                                    <VStack spacing={6}>

                                        <label>
                                            สถานะ
                                            <span className="text-danger"> *</span>
                                        </label>

                                        <RadioGroup
                                            value={status}
                                            appearance="picker"
                                            inline
                                            onChange={async val => {

                                                await this.promisedSetState({
                                                    status: val
                                                });

                                                this.onBusy({
                                                    type: "schedule",
                                                    mode,
                                                    id,
                                                    sel: true
                                                });

                                            }}
                                        >

                                            <Radio value={true}>
                                                <div style={{ color: 'green' }}>
                                                    ว่าง
                                                </div>
                                            </Radio>

                                            <Radio value={false}>
                                                <div style={{ color: 'red' }}>
                                                    ไม่ว่าง
                                                </div>
                                            </Radio>

                                        </RadioGroup>

                                    </VStack>

                                </Col>
                            </Row>

                        </Container>

                    </Modal.Body>


                    <Modal.Footer>

                        <Button
                            appearance="primary"
                            startIcon={<i className="bi bi-floppy-fill"></i>}
                            onClick={() =>
                                this.onConfirm({
                                    form: 'events',
                                    mode,
                                    id
                                })
                            }
                        >
                            บันทึก
                        </Button>

                        <Button
                            appearance="subtle"
                            onClick={() => this.setState({ modal: null })}
                        >
                            ยกเลิก
                        </Button>

                    </Modal.Footer>

                </Modal>

            );
        }

        await this.promisedSetState({
            modal: modalContent
        });

    };

    onModal = async ({ mode, id, sel, comfirm_id, by_admin, type, date }) => {

        let item = {};

        if (by_admin === true) {
            const response = await axios.get(`${process.env.REACT_APP_API}/student-consultation/${id}`, this.state.authHeader);
            item = response.data;
        }

        // ✅ Default data สำหรับ setState
        const defaultConsultData = {
            fetchedDate: '',
            fetchedSymbol: '',
            fetchedFullName: '',
            fetchedNickname: '',
            fetchedGender: '',
            fetchedAge: '',
            fetchedYearLevel: '',
            fetchedConsultTopic: [],
            fetchedNextField: '',
            fetchedConsultDetails: '',
            fetchedConsultMethod: '',
            fetchedMethodDetail: ''
        };

        const defaultRecommendationData = {
            full_name: item.full_name ? item.full_name : '',
            nickname: item.nickname ? item.nickname : '',
            age: item.age ? item.age : '',
            year_level: item.year_level ? item.year_level : '',
            gender: item.gender ? item.gender : '',
            youth_type: '',
            date: type === 'consult' ? date : '',
            consultant: '',
            topics: [],
            detail: '',
            suggestion: '',
            advice: [],
            recommendation: '',
            follow_up: '',
            cooperation: 'ดีมาก'
        };

        // ✅ กรณีที่ sel = false → โหลดข้อมูล
        if (!sel) {
            let consult = { ...defaultConsultData };
            let recommendation = { ...defaultRecommendationData };

            // ✅ Reset ก่อนทุกครั้ง (เฉพาะ sel = false เท่านั้น)
            if (!sel) {
                await this.promisedSetState({
                    approvedStudents: [],
                    student_id: '',
                    full_name: ''
                });
            }

            // 🚀 ดึงข้อมูล consult
            if (by_admin === true) {
                try {
                    const res1 = await axios.get(`${process.env.REACT_APP_API}/student-consultation/${id}`, this.state.authHeader);
                    const c = res1.data;

                    consult = {
                        fetchedDate: c.date || '',
                        fetchedSymbol: c.symbol || '',
                        fetchedFullName: c.full_name || '',
                        fetchedNickname: c.nickname || '',
                        fetchedGender: c.gender || '',
                        fetchedAge: c.age || '',
                        fetchedYearLevel: c.year_level || '',
                        fetchedConsultTopic: c.consult_topic ? JSON.parse(c.consult_topic) : [],
                        fetchedNextField: c.next_field || '',
                        fetchedConsultDetails: c.consult_details || '',
                        fetchedConsultMethod: c.consult_method || '',
                        fetchedMethodDetail: c.method_detail || ''
                    };
                } catch (e) {
                    console.warn('Error fetching consultation:', e);
                }
            }

            if (mode === 'update') {
                // 🚀 ดึงข้อมูล recommendation
                try {
                    const res2 = await axios.get(
                        `${process.env.REACT_APP_API}/recommendations/${comfirm_id}`,
                        this.state.authHeader
                    );
                    const r = res2.data;

                    if (r) {
                        recommendation = {
                            full_name: r.full_name || '',
                            nickname: r.nickname || '',
                            age: r.age || '',
                            year_level: r.year_level || '',
                            gender: r.gender || '',
                            youth_type: r.youth_type || '',
                            date: r.date || '',
                            consultant: r.consultant || '',
                            topics: r.topics ? JSON.parse(r.topics) : [],
                            detail: r.detail || '',
                            suggestion: r.suggestion || '',
                            advice: r.advice ? JSON.parse(r.advice) : [],
                            recommendation: r.recommendation || '',
                            follow_up: r.follow_up || '',
                            cooperation: r.cooperation || 'ดีมาก'
                        };
                    }
                } catch (e) {
                    console.warn('Error fetching recommendation:', e);
                }
            }

            // ✅ กรณี type === 'consult' (insert mode จาก onBusy) → reset ข้อมูลฟอร์ม
            if (type === 'consult') {
                recommendation = { ...defaultRecommendationData };
            }

            // ✅ รวมข้อมูล และตั้งค่า state
            await this.promisedSetState({
                ...consult,
                ...recommendation
            });
        }

        // ✅ เปิด modal
        await this.promisedSetState({
            modal: (
                <Modal size={'md'}
                    backdrop={'static'}
                    keyboard={false}
                    open={true}
                    onClose={() => this.setState({ modal: null })}
                >
                    <Modal.Header>
                        <Modal.Title style={{ fontWeight: '700', fontSize: '1.4rem' }}>
                            บันทึกการให้คำปรึกษา
                        </Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                        <Container fluid>
                            {by_admin === true && (
                                <>
                                    <label
                                        className="fw-bold mb-3 d-block"
                                        style={{
                                            borderBottom: '2px solid #ccc',
                                            paddingBottom: '4px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '8px',
                                            color: '#333'
                                        }}
                                    >
                                        <i className="bi bi-emoji-smile"></i> ผู้ยื่นขอคำขอปรึกษาและรายละเอียด
                                    </label>
                                    <Panel bordered style={{ backgroundColor: '#f9f9f9', padding: '16px', borderRadius: '6px' }} className='mt-2'>
                                        {/* วันที่นัดหมาย */}
                                        <FlexboxGrid>
                                            <FlexboxGrid.Item colspan={24}>
                                                <div>
                                                    <strong style={{ color: '#636363' }}>วันที่นัดหมาย : </strong> {this.formatThaiDate(this.state.fetchedDate)}
                                                </div>
                                            </FlexboxGrid.Item>
                                        </FlexboxGrid>

                                        {/* ข้อมูลส่วนตัวรวมอยู่ในบรรทัดน้อยลง */}
                                        <FlexboxGrid style={{ marginTop: 10 }} gutter={16}>
                                            <FlexboxGrid.Item colspan={24}>
                                                <div><strong style={{ color: '#636363' }}>ชื่อ - นามสกุล : </strong> {this.state.fetchedFullName}</div>
                                            </FlexboxGrid.Item>
                                        </FlexboxGrid>
                                        <FlexboxGrid style={{ marginTop: 10 }} gutter={16}>
                                            <FlexboxGrid.Item colspan={8}>
                                                <div><strong style={{ color: '#636363' }}>ชื่อเล่น : </strong> {this.state.fetchedNickname}</div>
                                            </FlexboxGrid.Item>
                                            <FlexboxGrid.Item colspan={6}>
                                                <div><strong style={{ color: '#636363' }}>เพศ : </strong> {this.state.fetchedGender}</div>
                                            </FlexboxGrid.Item>
                                        </FlexboxGrid>
                                        <FlexboxGrid style={{ marginTop: 10 }} gutter={16}>
                                            <FlexboxGrid.Item colspan={6}>
                                                <div><strong style={{ color: '#636363' }}>อายุ : </strong> {this.state.fetchedAge} ปี</div>
                                            </FlexboxGrid.Item>
                                            <FlexboxGrid.Item colspan={12}>
                                                <div><strong style={{ color: '#636363' }}>ระดับชั้นปี : </strong> {this.state.fetchedYearLevel}</div>
                                            </FlexboxGrid.Item>
                                        </FlexboxGrid>

                                        {/* หัวข้อที่ปรึกษา */}
                                        <div style={{ marginTop: 10 }}>
                                            <strong style={{ color: '#636363' }}>หัวข้อที่ต้องการขอคำปรึกษา</strong>
                                            <ul style={{ margin: '4px 0 0 24px', paddingLeft: '12px' }}>
                                                {this.state.fetchedConsultTopic.includes("stress") && <li>ความเครียดหรือวิตกกังวล</li>}
                                                {this.state.fetchedConsultTopic.includes("family") && <li>ความสัมพันธ์ในครอบครัว</li>}
                                                {this.state.fetchedConsultTopic.includes("gender") && <li>เพศและอัตลักษณ์</li>}
                                                {this.state.fetchedConsultTopic.includes("education") && <li>ปัญหาการเรียน</li>}
                                                {this.state.fetchedConsultTopic.includes("bullying") && <li>การถูกกลั่นแกล้ง</li>}
                                                {this.state.fetchedConsultTopic.includes("selfharm") && <li>ความคิดทำร้ายตัวเอง</li>}
                                                {this.state.fetchedConsultTopic.includes("other") && (
                                                    <li>อื่น ๆ: {this.state.fetchedNextField}</li>
                                                )}
                                            </ul>
                                        </div>

                                        {/* รายละเอียดที่อยากปรึกษา */}
                                        <div style={{ marginTop: 10 }}>
                                            <strong style={{ color: '#636363' }}>รายละเอียดหรือสิ่งที่ต้องการปรึกษา</strong>
                                            <div style={{ whiteSpace: 'pre-wrap', marginTop: 4 }}>
                                                {this.state.fetchedConsultDetails}
                                            </div>
                                        </div>

                                        {/* วิธีการให้คำปรึกษา */}
                                        <div style={{ marginTop: 10 }}>
                                            <strong style={{ color: '#636363' }}>ต้องการรับคำปรึกษาในรูปแบบใด</strong>
                                            <div style={{ marginTop: 4 }}>
                                                {this.state.fetchedConsultMethod === 'chat' && 'ผ่านข้อความ (แชท Line/Facebook)'}
                                                {this.state.fetchedConsultMethod === 'phone' && 'ผ่านโทรศัพท์'}
                                                {this.state.fetchedConsultMethod === 'in_person' && 'พบตัวต่อตัว'}
                                                {this.state.fetchedConsultMethod === 'unsure' && 'ไม่แน่ใจ / แล้วแต่ผู้ให้คำปรึกษาแนะนำ'}
                                            </div>
                                            {this.state.fetchedConsultMethod !== 'unsure' && (
                                                <div style={{ color: '#888', marginTop: 2 }}>
                                                    {this.state.fetchedMethodDetail}
                                                </div>
                                            )}
                                        </div>
                                    </Panel>

                                    <label
                                        className="fw-bold mt-4 mb-3 d-block"
                                        style={{
                                            borderBottom: '2px solid #ccc',
                                            paddingBottom: '4px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '8px',
                                            color: '#333'
                                        }}
                                    >
                                        <i className="bi bi-file-earmark-text"></i> บันทึกการให้คำปรึกษา
                                    </label>
                                </>
                            )}

                            {/* ✅ ประเภทเยาวชน — แสดงทุกครั้ง */}
                            <Row className="mb-3">
                                <Col>
                                    <VStack spacing={8}>
                                        <label>
                                            ประเภทเยาวชนทั่วไป / นักเรียนทุน <span className="text-danger">*</span>
                                        </label>
                                        <SelectPicker
                                            className="Xz3Q9"
                                            size="lg"
                                            data={[
                                                { value: 'เยาวชนทั่วไป', label: 'เยาวชนทั่วไป' },
                                                { value: 'นักเรียนทุน', label: 'นักเรียนทุน' }
                                            ]}
                                            value={this.state.youth_type}
                                            searchable={false}
                                            style={{ width: 180 }}
                                            placeholder="กรุณาเลือกรายการ"
                                            onChange={async (youth_type) => {
                                                await this.promisedSetState({ youth_type, loading: true });

                                                if (youth_type === 'นักเรียนทุน') {
                                                    try {
                                                        const response = await axios.get(
                                                            `${process.env.REACT_APP_API}/application/approved`,
                                                            this.state.authHeader
                                                        );
                                                        const options = response.data.map(item => ({
                                                            value: item.id,
                                                            label: item.first_name + ' ' + item.last_name
                                                        }));
                                                        await this.promisedSetState({
                                                            approvedStudents: options,
                                                            loading: false
                                                        });
                                                    } catch (err) {
                                                        console.error(err);
                                                        await this.promisedSetState({ loading: false });
                                                    }
                                                } else {
                                                    await this.promisedSetState({
                                                        approvedStudents: [],
                                                        loading: false
                                                    });
                                                }

                                                this.onModal({ mode, id, sel: true, comfirm_id, by_admin, type, date });
                                            }}
                                            onClean={async () => {
                                                await this.promisedSetState({
                                                    youth_type: '',
                                                    approvedStudents: [],
                                                    full_name: '',
                                                    student_id: '',
                                                    loading: false
                                                });
                                                this.onModal({ mode, id, sel: true, comfirm_id, by_admin, type, date });
                                            }}
                                        />
                                    </VStack>
                                </Col>
                            </Row>

                            {/* ชื่อ - นามสกุล */}
                            <Row className="mb-3 mt-3">
                                <Col md={6}>
                                    <VStack spacing={8}>
                                        <label>ชื่อ - นามสกุล <span className="text-danger">*</span></label>
                                        {type === 'consult' && this.state.youth_type === 'นักเรียนทุน' ? (
                                            <SelectPicker
                                                className="gT3kQ"
                                                size='lg'
                                                data={this.state.approvedStudents || []}
                                                labelKey="label"
                                                valueKey="value"
                                                value={this.state.student_id || null}
                                                placeholder="เลือกนักเรียนทุน"
                                                searchable
                                                loading={this.state.loading}
                                                style={{ width: '100%' }}
                                                onChange={async (studentId) => {
                                                    const selected = this.state.approvedStudents.find(
                                                        item => item.value === studentId
                                                    );

                                                    await this.promisedSetState({
                                                        student_id: studentId,
                                                        full_name: selected?.label || ''
                                                    });

                                                    this.onModal({
                                                        mode,
                                                        id: studentId,
                                                        sel: true,
                                                        comfirm_id: null,
                                                        by_admin: false,
                                                        type,
                                                        date
                                                    });
                                                }}
                                                onClean={async () => {
                                                    await this.promisedSetState({
                                                        student_id: '',
                                                        full_name: ''
                                                    });
                                                }}
                                            />
                                        ) : (
                                            <Input
                                                key={type === 'consult' ? this.state.youth_type : 'admin'}
                                                className='gT3kQ'
                                                size="sm"
                                                defaultValue={this.state.full_name}
                                                onChange={full_name => this.setState({ full_name })}
                                            />
                                        )}
                                    </VStack>
                                </Col>
                                <Col md={3}>
                                    <VStack spacing={8}>
                                        <label>ชื่อเล่น <span className="text-danger">*</span></label>
                                        <Input
                                            className='P9xW4'
                                            size="sm"
                                            defaultValue={this.state.nickname}
                                            onChange={nickname => this.setState({ nickname })}
                                        />
                                    </VStack>
                                </Col>
                            </Row>

                            <Row className="mb-3">
                                <Col md={2}>
                                    <VStack spacing={8}>
                                        <label>อายุ <span className="text-danger">*</span></label>
                                        <InputNumber
                                            className='r2N8L'
                                            size='lg'
                                            min={0}
                                            defaultValue={this.state.age || 0}
                                            onChange={age => this.setState({ age })}
                                        />
                                    </VStack>
                                </Col>
                                <Col md={3}>
                                    <VStack spacing={8}>
                                        <label>ระดับชั้นปี <span className="text-danger">*</span></label>
                                        <Input
                                            className='Kc71M'
                                            size="sm"
                                            defaultValue={this.state.year_level}
                                            onChange={year_level => this.setState({ year_level })}
                                        />
                                    </VStack>
                                </Col>
                                <Col md={3}>
                                    <VStack spacing={8}>
                                        <label>เพศ <span className="text-danger">*</span></label>
                                        <SelectPicker
                                            className='vB8pZ'
                                            size='lg'
                                            data={[
                                                { value: 'ชาย', label: 'ชาย' },
                                                { value: 'หญิง', label: 'หญิง' },
                                                { value: 'ไม่ระบุ', label: 'ไม่ระบุ' },
                                                { value: 'อื่นๆ', label: 'อื่นๆ' }
                                            ]}
                                            defaultValue={this.state.gender}
                                            searchable={false}
                                            style={{ width: 120 }}
                                            placeholder="กรุณาเลือกรายการ"
                                            onChange={gender => this.setState({ gender })}
                                            onClean={() => this.setState({ gender: '' })}
                                        />
                                    </VStack>
                                </Col>
                            </Row>

                            <Row className="mb-3">
                                <Col>
                                    <VStack spacing={8}>
                                        <label>วันที่ให้คำปรึกษา <span className="text-danger">*</span></label>
                                        <div className='tN6Yd' style={{ display: 'flex', alignItems: 'center' }}>
                                            <ThaiDatePicker
                                                placeholder="วัน/เดือน/ปี พ.ศ."
                                                value={this.state.date}
                                                inputProps={{
                                                    style: {
                                                        padding: '6px 8px',
                                                        borderRadius: '6px 0 0 6px',
                                                        border: '1px solid #E7E5E4',
                                                        width: '200px',
                                                    }
                                                }}
                                                onChange={async date => {
                                                    await this.promisedSetState({ date });
                                                    this.onModal({ mode, id, sel: true, comfirm_id, by_admin, type, date });
                                                }}
                                                onClean={async () => {
                                                    await this.promisedSetState({ date: '' });
                                                    this.onModal({ mode, id, sel: true, comfirm_id, by_admin, type, date: '' });
                                                }}
                                            />
                                            <IconButton
                                                icon={<i className="bi bi-calendar3"></i>}
                                                size="md"
                                                style={{
                                                    borderRadius: '0 6px 6px 0',
                                                }}
                                            />
                                        </div>
                                    </VStack>
                                </Col>
                            </Row>

                            <Row className="mb-3">
                                <Col>
                                    <VStack spacing={8}>
                                        <label>ชื่อผู้ให้คำปรึกษา <span className="text-danger">*</span></label>
                                        <Input
                                            className='Mj2pW'
                                            size="sm"
                                            defaultValue={this.state.consultant}
                                            onChange={consultant => this.setState({ consultant })}
                                        />
                                    </VStack>
                                </Col>
                            </Row>

                            <Row className="mb-3">
                                <Col>
                                    <VStack spacing={8}>
                                        <label className="fw-bold">ประเด็นหรือปัญหาที่นำมาปรึกษา (เลือกได้มากกว่าหนึ่งข้อ)</label>
                                        <CheckboxGroup
                                            className='QW9e4'
                                            defaultValue={this.state.topics}
                                            onChange={topics => this.setState({ topics })}
                                        >
                                            <Checkbox value="family">ปัญหาครอบครัว</Checkbox>
                                            <Checkbox value="relationship">ปัญหาความรัก/ความสัมพันธ์</Checkbox>
                                            <Checkbox value="emotional">ปัญหาทางอารมณ์ (เครียด วิตก ซึมเศร้า ฯลฯ)</Checkbox>
                                            <Checkbox value="academic">ปัญหาการเรียน/การบ้าน/เกรด</Checkbox>
                                            <Checkbox value="social">ปัญหาเพื่อน/การเข้าสังคม</Checkbox>
                                            <Checkbox value="behavior">ปัญหาพฤติกรรม (เช่น หนีเรียน ติดเกม ฯลฯ)</Checkbox>
                                            <Checkbox value="health_risk">ปัญหาสุขภาพ/พฤติกรรมเสี่ยง</Checkbox>
                                            <Checkbox value="other">อื่นๆ โปรดระบุ</Checkbox>
                                            <Input
                                                className='Zp83x'
                                                size="md"
                                                defaultValue={this.state.detail}
                                                onChange={detail => this.setState({ detail })}
                                            />
                                        </CheckboxGroup>
                                    </VStack>
                                </Col>
                            </Row>

                            <Row className="mb-3">
                                <Col>
                                    <VStack spacing={8}>
                                        <label className="fw-bold">รายละเอียดการสนทนาหรือให้คำปรึกษา <span className="text-danger">*</span></label>
                                        <Input
                                            className='La7Mk'
                                            as="textarea"
                                            rows={4}
                                            defaultValue={this.state.suggestion}
                                            onChange={suggestion => this.setState({ suggestion })}
                                        />
                                    </VStack>
                                </Col>
                            </Row>

                            <Row className="mb-3">
                                <Col>
                                    <VStack spacing={8}>
                                        <label className="fw-bold">แนวทางที่แนะนำ / การช่วยเหลือที่ดำเนินการ</label>
                                        <CheckboxGroup
                                            className='dT9xR'
                                            defaultValue={this.state.advice}
                                            onChange={async advice => {
                                                await this.promisedSetState({ advice });
                                                this.onModal({ mode, id, sel: true, comfirm_id, by_admin, type, date });
                                            }}
                                        >
                                            <Checkbox value="recommendation">คำแนะนำที่ให้</Checkbox>
                                            {this.state.advice.includes('recommendation') && (
                                                <Input
                                                    className='BxW03'
                                                    style={{ marginLeft: '1em' }}
                                                    size="sm"
                                                    placeholder='โปรดระบุ'
                                                    defaultValue={this.state.recommendation}
                                                    onChange={recommendation => this.setState({ recommendation })}
                                                />
                                            )}

                                            <Checkbox value="follow_up_plan">แผนการติดตาม / นัดหมายครั้งถัดไป (ถ้ามี)</Checkbox>
                                            {this.state.advice.includes('follow_up_plan') && (
                                                <Input
                                                    className='wN5qE'
                                                    style={{ marginLeft: '1em' }}
                                                    size="md"
                                                    placeholder='โปรดระบุ'
                                                    defaultValue={this.state.follow_up}
                                                    onChange={follow_up => this.setState({ follow_up })}
                                                />
                                            )}

                                            <Checkbox value="cooperation">ความร่วมมือจากผู้รับคำปรึกษา</Checkbox>
                                            {this.state.advice.includes('cooperation') && (
                                                <RadioGroup
                                                    className='W4puB'
                                                    style={{ marginLeft: '1em' }}
                                                    name="cooperation_level"
                                                    defaultValue={this.state.cooperation || "ดีมาก"}
                                                    onChange={cooperation => this.setState({ cooperation })}
                                                >
                                                    <Radio value="ดีมาก">ดีมาก</Radio>
                                                    <Radio value="ดี">ดี</Radio>
                                                    <Radio value="ปานกลาง">ปานกลาง</Radio>
                                                    <Radio value="ต้องติดตามใกล้ชิด">ต้องติดตามใกล้ชิด</Radio>
                                                </RadioGroup>
                                            )}
                                        </CheckboxGroup>
                                    </VStack>
                                </Col>
                            </Row>
                        </Container>
                    </Modal.Body>

                    <Modal.Footer>
                        <Button
                            size="md"
                            appearance="primary"
                            startIcon={<i className="bi bi-floppy-fill"></i>}
                            onClick={() => this.onConfirm({
                                form: 'consult',
                                mode: mode,
                                id: comfirm_id,
                                ...(type === 'consult' && { student_id: this.state.student_id })
                            })}
                        >
                            บันทึก
                        </Button>
                        <Button
                            size="md"
                            appearance="subtle"
                            onClick={() => this.setState({ modal: null })}
                        >
                            ยกเลิก
                        </Button>
                    </Modal.Footer>
                </Modal>
            )
        });
    };

    Validate = async (value, className, expected = '') => {
        try {
            // Trim ค่า string เพื่อกัน user ใส่ช่องว่างเปล่า
            const input = typeof value === 'string' ? value.trim() : value;

            // ตรวจสอบว่า className ถูกต้องหรือไม่
            if (!className || typeof className !== 'string') {
                console.warn(`Invalid className: "${className}"`);
                return false;
            }

            // เปรียบเทียบค่า input กับ expected
            const isValid = input !== expected;

            const $element = $('.' + className);
            if (!$element.length) {
                console.warn(`DOM element with class ".${className}" not found.`);
            }

            if (!isValid) {
                $element.addClass('required');

                await Swal.fire({
                    title: "กรุณากรอกข้อมูลให้ครบถ้วน",
                    icon: "warning",
                    timer: 2000,
                    timerProgressBar: true,
                    confirmButtonText: `<div style="font-size: 1.425rem">ตกลง</div>`,
                });

                return false;
            } else {
                $element.removeClass('required');
                return true;
            }
        } catch (error) {
            console.error('Validation error:', error);
            return false;
        }
    };

    onConfirm = async ({ form, mode, id, student_id }) => {
        if (form === 'events') {

            const validateEvents = async () => {
                const validationPromises = [
                    this.Validate(this.state.date, 'QN0Vv', ''),
                    this.Validate(this.state.status, '3DrpM', '')
                ];
                const results = await Promise.all(validationPromises);
                return results.every(result => result === true);
            };

            if (await validateEvents()) {
                try {
                    this.setState({ loading: true });

                    // ✅ FIX: กัน false เพี้ยน
                    const payload = {
                        date: this.state.date || '',
                        status: this.state.status === true
                    };

                    console.log("payload:", payload);

                    // ================= INSERT =================
                    if (mode === 'insert') {
                        const response = await axios.post(
                            `${process.env.REACT_APP_API}/events`,
                            payload,
                            this.state.authHeader
                        );

                        if (response.data.message === 'successfully') {

                            await this.promisedSetState({
                                date: '',
                                status: null // ✅ ห้ามใช้ ''
                            });

                            await this.onRenderContent({ mode: 'read' });

                            this.setState({ modal: null });

                            Swal.fire({
                                title: "บันทึกข้อมูลเรียบร้อยแล้ว",
                                icon: "success",
                                timer: 2000,
                                showConfirmButton: false
                            });
                        }
                    }

                    // ================= UPDATE =================
                    else if (mode === 'update') {
                        const response = await axios.patch(
                            `${process.env.REACT_APP_API}/events`,
                            {
                                id,
                                ...payload
                            },
                            this.state.authHeader
                        );

                        if (response.data.message === 'updated successfully') {

                            await this.promisedSetState({
                                date: '',
                                status: null
                            });

                            await this.onRenderContent({ mode: 'read' });

                            this.setState({ modal: null });

                            Swal.fire({
                                title: "บันทึกข้อมูลเรียบร้อยแล้ว",
                                icon: "success",
                                timer: 2000,
                                showConfirmButton: false
                            });
                        }
                    }

                } catch (error) {
                    console.error(error);

                    Swal.fire({
                        title: "เกิดข้อผิดพลาด",
                        text: error.response?.data?.error || error.message,
                        icon: "error",
                    });

                } finally {
                    this.setState({ loading: false });
                }
            }

        } else if (form === 'consult') {
            // --------------------- DELETE MODE ---------------------
            if (mode === 'delete') {
                Swal.fire({
                    title: `คุณต้องการลบข้อมูลใช่หรือไม่?`,
                    html: `<div style="font-size: 1.4rem">ระบบจะลบเฉพาะข้อมูลบันทึกการให้คำปรึกษาเท่านั้น</div>`,
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#3085d6",
                    cancelButtonColor: "#d33",
                    confirmButtonText: `<div style="font-size: 1.2rem">ตกลง</div>`,
                    cancelButtonText: `<div style="font-size: 1.2rem">ยกเลิก</div>`
                }).then(async (result) => {
                    if (result.isConfirmed) {
                        try {
                            this.setState({ loading: true });

                            const response = await axios.delete(
                                `${process.env.REACT_APP_API}/recommendations/${id}`,
                                this.state.authHeader
                            );

                            const data = response.data;

                            if (data.message === 'successfully') {
                                Swal.fire({
                                    title: "ลบข้อมูลเรียบร้อยแล้ว",
                                    icon: "success",
                                    timer: 2000,
                                    timerProgressBar: true,
                                    confirmButtonText: `<div style="font-size: 1.425rem">ตกลง</div>`,
                                }).then(async () => {
                                    await this.onRenderContent({ mode: 'read' });
                                    this.setState({ modal: null });
                                });
                            } else if (data.message === 'Recommendation not found') {
                                Swal.fire({
                                    title: "ไม่พบข้อมูลการให้คำปรึกษา",
                                    icon: "warning",
                                    confirmButtonText: `<div style="font-size: 1.425rem">ตกลง</div>`,
                                });
                            } else {
                                Swal.fire({
                                    title: "เกิดข้อผิดพลาดในการลบ",
                                    text: data.message || 'ไม่สามารถลบข้อมูลได้',
                                    icon: "error",
                                    confirmButtonText: `<div style="font-size: 1.425rem">ตกลง</div>`,
                                });
                            }
                        } catch (e) {
                            const msg = e.response?.data?.message || '';
                            Swal.fire({
                                title: msg === 'Recommendation not found' ? "ไม่พบข้อมูลการให้คำปรึกษา" : "เกิดข้อผิดพลาดในการลบ",
                                text: msg === 'Recommendation not found' ? '' : msg || 'ไม่สามารถลบข้อมูลได้',
                                icon: msg === 'Recommendation not found' ? "warning" : "error",
                                confirmButtonText: `<div style="font-size: 1.425rem">ตกลง</div>`,
                            });
                        } finally {
                            this.setState({ loading: false });
                        }
                    }
                });

                return;
            }

            const validateConsult = async () => {
                const validationPromises = [
                    this.Validate(this.state.full_name, 'gT3kQ', ''),
                    this.Validate(this.state.nickname, 'P9xW4', ''),
                    this.Validate(this.state.age, 'r2N8L', ''),
                    this.Validate(this.state.year_level, 'Kc71M', ''),
                    this.Validate(this.state.gender, 'vB8pZ', ''),
                    this.Validate(this.state.youth_type, 'Xz3Q9', ''),
                    this.Validate(this.state.date, 'tN6Yd', ''),
                    this.Validate(this.state.consultant, 'Mj2pW', ''),

                    ...(this.state.topics.includes('other')
                        ? [this.Validate(this.state.detail, 'Zp83x', '')]
                        : []),

                    this.Validate(this.state.suggestion, 'La7Mk', ''),
                    this.Validate(this.state.advice, 'dT9xR', ''),

                    ...(this.state.advice.includes('recommendation')
                        ? [this.Validate(this.state.recommendation, 'BxW03', '')]
                        : []),

                    ...(this.state.advice.includes('follow_up_plan')
                        ? [this.Validate(this.state.follow_up, 'wN5qE', '')]
                        : []),

                    ...(this.state.advice.includes('cooperation')
                        ? [this.Validate(this.state.cooperation, 'W4puB', '')]
                        : []),
                ];

                const results = await Promise.all(validationPromises);
                return results.every(result => result === true);
            };

            if (await validateConsult()) {
                try {
                    this.setState({ loading: true });

                    if (mode === 'insert') {
                        // ถ้าผ่าน validation ส่งข้อมูล POST ไปที่ API
                        const payload = {
                            student_consultations_id: id || null,
                            scholarship_student_id: student_id || null,
                            full_name: this.state.full_name || '',
                            nickname: this.state.nickname || '',
                            age: this.state.age || 0,
                            year_level: this.state.year_level || '',
                            gender: this.state.gender || '',
                            youth_type: this.state.youth_type || '',
                            date: this.state.date || '',
                            consultant: this.state.consultant || '',
                            topics: this.state.topics || '',
                            detail: this.state.detail || '',
                            suggestion: this.state.suggestion || '',
                            advice: this.state.advice || '',
                            recommendation: this.state.recommendation || '',
                            follow_up: this.state.follow_up || '',
                            cooperation: this.state.cooperation || '',
                        };

                        const response = await axios.post(
                            `${process.env.REACT_APP_API}/recommendations`,
                            payload,
                            this.state.authHeader
                        );

                        const data = response.data;

                        if (data.message === 'successfully' || response.status === 201) {
                            Swal.fire({
                                title: "บันทึกข้อมูลเรียบร้อยแล้ว",
                                icon: "success",
                                timer: 2000,
                                timerProgressBar: true,
                                confirmButtonText: `<div style="font-size: 1.425rem">ตกลง</div>`,
                            }).then(async () => {
                                await this.promisedSetState({
                                    full_name: '',
                                    nickname: '',
                                    age: 0,
                                    year_level: '',
                                    gender: '',
                                    youth_type: '',
                                    date: '',
                                    consultant: '',
                                    topics: '',
                                    detail: '',
                                    suggestion: '',
                                    advice: '',
                                    recommendation: '',
                                    follow_up: '',
                                    cooperation: '',
                                    modal: null
                                });
                                await this.onRenderContent({ mode: 'read' });
                            });
                        } else {
                            // กรณีส่งไม่สำเร็จ แต่ไม่ใช่ error
                            Swal.fire({
                                title: "เกิดข้อผิดพลาดในการบันทึกข้อมูล",
                                icon: "error",
                                confirmButtonText: `ตกลง`,
                            });
                        }
                    } else if (mode === 'update') {
                        const payload = {
                            id: id || 0,
                            full_name: this.state.full_name || '',
                            nickname: this.state.nickname || '',
                            age: this.state.age || 0,
                            year_level: this.state.year_level || '',
                            gender: this.state.gender || '',
                            youth_type: this.state.youth_type || '',
                            date: this.state.date || '',
                            consultant: this.state.consultant || '',
                            topics: this.state.topics || '',
                            detail: this.state.detail || '',
                            suggestion: this.state.suggestion || '',
                            advice: this.state.advice || '',
                            recommendation: this.state.recommendation || '',
                            follow_up: this.state.follow_up || '',
                            cooperation: this.state.cooperation || '',
                        };

                        try {
                            const response = await axios.patch(
                                `${process.env.REACT_APP_API}/recommendations/${id}`,
                                payload,
                                this.state.authHeader
                            );

                            const data = response.data;

                            if (data.message === 'successfully' || response.status === 200) {
                                Swal.fire({
                                    title: "แก้ไขข้อมูลเรียบร้อยแล้ว",
                                    icon: "success",
                                    timer: 2000,
                                    timerProgressBar: true,
                                    confirmButtonText: `<div style="font-size: 1.425rem">ตกลง</div>`,
                                }).then(async () => {
                                    await this.promisedSetState({
                                        full_name: '',
                                        nickname: '',
                                        age: 0,
                                        year_level: '',
                                        gender: '',
                                        youth_type: '',
                                        date: '',
                                        consultant: '',
                                        topics: '',
                                        detail: '',
                                        suggestion: '',
                                        advice: '',
                                        recommendation: '',
                                        follow_up: '',
                                        cooperation: '',
                                        modal: null
                                    });
                                    await this.onRenderContent({ mode: 'read' });
                                });
                            } else {
                                Swal.fire({
                                    title: "เกิดข้อผิดพลาดในการแก้ไขข้อมูล",
                                    icon: "error",
                                    confirmButtonText: `ตกลง`,
                                });
                            }
                        } catch (error) {
                            Swal.fire({
                                title: "เกิดข้อผิดพลาดในการเชื่อมต่อ",
                                text: error.message || 'Unknown error',
                                icon: "error",
                                confirmButtonText: `ตกลง`,
                            });
                        }
                    }
                } catch (error) {
                    Swal.fire({
                        title: "เกิดข้อผิดพลาด",
                        text: error.message,
                        icon: "error",
                        confirmButtonText: `<div style="font-size: 1.425rem">ตกลง</div>`,
                    });
                } finally {
                    this.setState({ loading: false });
                }
            }

        }
    };

    downloadExcel = async () => {
        try {

            const res = await axios.get(
                `${process.env.REACT_APP_API}/recommendations`,
                this.state.authHeader
            );

            const data = res.data || [];

            // แปลงวันที่ให้ปลอดภัย
            const parseDate = (date) => {
                if (!date) return new Date(0);
                return new Date(date);
            };

            // format วันที่ไทย
            const formatThaiDate = (date) => {
                if (!date) return "";

                const d = new Date(date);

                const day = String(d.getDate()).padStart(2, "0");
                const month = String(d.getMonth() + 1).padStart(2, "0");
                const year = d.getFullYear() + 543;

                return `${day}/${month}/${year}`;
            };

            // เรียงวันที่ให้คำปรึกษา ล่าสุดก่อน
            const sortedData = [...data].sort((a, b) => {
                return parseDate(b.date) - parseDate(a.date);
            });

            const rows = sortedData.map((r, i) => {

                const topics = r.topics || [];
                const advice = r.advice || [];

                return {
                    "ลำดับ": i + 1,
                    "วันที่ให้คำปรึกษา": formatThaiDate(r.date),
                    "ชื่อ - นามสกุล": r.full_name,
                    "ชื่อเล่น": r.nickname,
                    "อายุ": r.age,
                    "ระดับชั้นปี": r.year_level,
                    "เพศ": r.gender,
                    "ประเภทเยาวชนทั่วไป/นักเรียนทุน": r.youth_type,
                    "ชื่อผู้ให้คำปรึกษา": r.consultant,

                    "ปัญหาครอบครัว": topics.includes("family") ? "✓" : "",
                    "ปัญหาความรัก/ความสัมพันธ์": topics.includes("relationship") ? "✓" : "",
                    "ปัญหาทางอารมณ์ (เครียด วิตก ซึมเศร้า ฯลฯ)": topics.includes("emotional") ? "✓" : "",
                    "ปัญหาการเรียน/การบ้าน/เกรด": topics.includes("academic") ? "✓" : "",
                    "ปัญหาเพื่อน/การเข้าสังคม": topics.includes("social") ? "✓" : "",
                    "ปัญหาพฤติกรรม (เช่น หนีเรียน ติดเกม ฯลฯ)": topics.includes("behavior") ? "✓" : "",
                    "ปัญหาสุขภาพ/พฤติกรรมเสี่ยง": topics.includes("health_risk") ? "✓" : "",
                    "อื่นๆ": topics.includes("other") ? r.detail : "",

                    "รายละเอียดการสนทนาหรือให้คำปรึกษา": r.suggestion,

                    "คำแนะนำที่ให้": advice.includes("recommendation") ? r.recommendation : "",
                    "แผนการติดตาม / นัดหมายครั้งถัดไป": advice.includes("follow_up_plan") ? r.follow_up : "",
                    "ความร่วมมือจากผู้รับคำปรึกษา": advice.includes("cooperation") ? r.cooperation : "",

                    "วันที่บันทึก": formatThaiDate(r.createdAt)
                };
            });

            const worksheet = XLSX.utils.json_to_sheet(rows);
            const workbook = XLSX.utils.book_new();

            XLSX.utils.book_append_sheet(workbook, worksheet, "Consultation");

            // random file name
            const randomFileName = () => {
                const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
                let result = "";
                for (let i = 0; i < 8; i++) {
                    result += chars.charAt(Math.floor(Math.random() * chars.length));
                }
                return result;
            };

            const fileName = `${randomFileName()}.xlsx`;

            XLSX.writeFile(workbook, fileName);

        } catch (error) {
            console.error("Export Excel Error:", error);
        }
    };

    render() {

        const FullPageLoader = () => (
            <div style={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                backgroundColor: 'rgba(255, 255, 255, 0.8)', // Semi-transparent background
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: 9999 // Ensure it's on top of other content
            }}>
                <Loader content="Loading..." /> {/* Adjust loader component as needed */}
            </div>
        );

        return (
            <>
                {this.state.content}
                {this.state.modal}
                {this.state.loading && <FullPageLoader />}
            </>
        );
    }
}